import { useQuery } from "@apollo/client";
import { LIVE_EVENT_DETAILS } from "@/api/queries/liveEventDetails";
import {
  LiveEventAudienceEnum,
  LiveEventTypeEnum,
} from "@/__generated__/types";

export interface LiveEventDetails {
  id: string;
  audience: LiveEventAudienceEnum | null;
  chatChannel: {
    displayName: string;
  } | null;
  eventType: LiveEventTypeEnum | null;
  gameType: string | null | undefined;
  gameVariation: string | null | undefined;
  name: string | null;
  startsAt: number;
}

export interface UseLiveEventDetailsReturn {
  liveEvent: LiveEventDetails | null;
  loading: boolean;
  error: unknown;
}

export const useLiveEventDetails = (
  eventId?: string,
): UseLiveEventDetailsReturn => {
  const { data, loading, error } = useQuery(LIVE_EVENT_DETAILS, {
    variables: {
      eventId: eventId || "",
    },
    skip: !eventId,
  });

  const liveEvent: LiveEventDetails | null = (() => {
    if (!data?.node || data.node.__typename !== "LiveEvent") {
      return null;
    }

    return {
      id: data.node.id,
      audience: data.node.audience,
      chatChannel: data.node.chatChannel,
      eventType: data.node.eventType,
      gameType: data.node.gameType,
      gameVariation: data.node.gameVariation,
      name: data.node.name,
      startsAt: data.node.startsAt,
    };
  })();

  return {
    liveEvent,
    loading,
    error,
  };
};
